__turbopack_context__.v({
  "taskTimeEntrySelect": "CxlGNW_taskTimeEntrySelect",
  "taskTimeEntrySelect__controls": "CxlGNW_taskTimeEntrySelect__controls",
  "taskTimeEntrySelect__empty": "CxlGNW_taskTimeEntrySelect__empty",
  "taskTimeEntrySelect__emptyTrigger": "CxlGNW_taskTimeEntrySelect__emptyTrigger",
  "taskTimeEntrySelect__list": "CxlGNW_taskTimeEntrySelect__list",
  "taskTimeEntrySelect__meta": "CxlGNW_taskTimeEntrySelect__meta",
  "taskTimeEntrySelect__meters": "CxlGNW_taskTimeEntrySelect__meters",
  "taskTimeEntrySelect__option": "CxlGNW_taskTimeEntrySelect__option",
  "taskTimeEntrySelect__panel": "CxlGNW_taskTimeEntrySelect__panel",
  "taskTimeEntrySelect__selectedMeta": "CxlGNW_taskTimeEntrySelect__selectedMeta",
  "taskTimeEntrySelect__selectedTitle": "CxlGNW_taskTimeEntrySelect__selectedTitle",
  "taskTimeEntrySelect__selectedTitleText": "CxlGNW_taskTimeEntrySelect__selectedTitleText",
  "taskTimeEntrySelect__taskName": "CxlGNW_taskTimeEntrySelect__taskName",
  "taskTimeEntrySelect__title": "CxlGNW_taskTimeEntrySelect__title",
  "taskTimeEntrySelect__trigger": "CxlGNW_taskTimeEntrySelect__trigger",
});
